export default "__VITE_ASSET__DO7ukKdv__"